export const INVOICE_MEDIA_TYPES: Record<string, string> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp'
};

export const INVOICE_ACCEPTED_TYPES: string = '.pdf,.jpg,.jpeg,.png,.webp';

export const INVOICE_MAX_SIZE_MB: number = 10;

export const INVOICE_MAX_SIZE_BYTES: number = INVOICE_MAX_SIZE_MB * 1024 * 1024;

export const INVOICE_MAX_FILE_NAME_LENGTH: number = 255;